// Default landing - composes the full firm dashboard.
// Ported from prototype's FirmOverview component.

import { useState } from "react";
import { useCurrentUser } from "../auth/CurrentUserContext";
import { isAdminRole } from "../../lib/roles";
import { HeroMetrics } from "./HeroMetrics";
import { PracticeMixGrid } from "./PracticeMixGrid";
import { DeadlineRadar } from "./DeadlineRadar";
import { AIStream } from "./AIStream";
import { PipelineByArea } from "./PipelineByArea";
import { WorkspaceCard } from "./WorkspaceCard";
import { PriorityQueue } from "./PriorityQueue";
import { StaffWorkload } from "./StaffWorkload";
import { TeamSection } from "./TeamSection";

interface Props {
  onOpenSearch?: () => void;
}

export function FirmCommandCenter({ onOpenSearch }: Props = {}) {
  const [practiceFilter, setPracticeFilter] = useState<string>("all");
  // The firm's mailbox, Drive and calendar: the server answers them to admin+ only.
  const isAdmin = isAdminRole(useCurrentUser()?.role);

  return (
    <main className="cc-main">
      <div className="cc-body">
        <HeroMetrics />
        <PracticeMixGrid />
        <div className="cc-grid-a">
          <DeadlineRadar onOpenSearch={onOpenSearch} />
          <AIStream />
        </div>
        <PipelineByArea practiceFilter={practiceFilter} setPracticeFilter={setPracticeFilter} />
        {isAdmin && <WorkspaceCard />}
        <div className="cc-grid-b">
          <PriorityQueue />
          <StaffWorkload />
        </div>
        <TeamSection />
      </div>
    </main>
  );
}
